import { FormInput_text } from 'components/form/formInput/FormInput_text';
import { FormInput_textarea } from 'components/form/formInput/FormInput_textarea';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import usePromiseInstance_authorization from 'dataflow/distributorPortal/actions/config';
import { cloneObject, func_serviceHandling, func_validation, getArrayLength, getObjectLength, isArrayNotEmpty, isBooleanFalseNotNullUndefined, isStringTrimNotEmpty } from 'functions';
import React, { useEffect, useRef, useState } from 'react';

export function useTableActions({ requestType }) {
    const requestingSingleRowPos = useRef();

    const totalPendingRequests = useRef(0);
    const [selectedCOMs, setSelectedCOMs] = useState();
    const [selectedCOMReasons, setSelectedCOMReasons] = useState({});
    const [isRequestingMultiple, setIsRequestingMultiple] = useState();

    const [singleCOMDetail, setSingleCOMDetail] = useState({});
    const [singleCOMReason, setSingleCOMReason] = useState("");

    const [isSingleRequest, setIsSingleRequest] = useState();
    const [isModalVisible, setIsModalVisible] = useState();
    const [isRequestSuccessful, setIsRequestSuccessful] = useState();
    const [isRerenderingRequired, setIsRerenderingRequired] = useState();
    const request = usePromiseInstance_authorization();

    useEffect(() => {
        if (!isModalVisible) {
            setSingleCOMReason("");
            setSelectedCOMReasons({});
        }
    }, [isModalVisible]);

    let isProjectInProduction = (process.env.NODE_ENV === "production");

    function requestMultipleCom() {
        if (func_validation.isArrayNotEmpty(selectedCOMs)) {
            setIsRequestingMultiple(true);
            setIsRequestSuccessful(false);
            totalPendingRequests.current = selectedCOMs.length;

            selectedCOMs.map((comDetails, idx) => {
                let comId = comDetails?.comId;

                let reason_formatted = selectedCOMReasons?.[idx]? selectedCOMReasons[idx]:"";

                let paramObj = {
                    sendEmail: isProjectInProduction,
                    requestReason: reason_formatted,
                }
        
                let url = func_serviceHandling.createUrlWithParams((requestType.current == "COM Reactivation"? "/ComInfo/PostReactiveRequest/":"/ComInfo/PostTrialToBillableRequest/") + comId, paramObj);

                if (comId) {
                    request(null, (axios) => {
                        axios.post(url)
                            .then((response) => {
                                Toaster({
                                    type: "success",
                                    msg: "Successfully requested COM(s)"
                                });
    
                                if (totalPendingRequests.current == 1) {
                                    setSelectedCOMs([]);
                                    setIsRequestSuccessful(true);
                                }
                            })
                            .catch((response) => {
                                let originalMsg = response?.data?.exceptionMessage;
                                Toaster({
                                    type: "error",
                                    msg: originalMsg? originalMsg: "Failed to request COM",
                                    timer: 7000
                                })
                            })
                            .then(() => {
                                totalPendingRequests.current = totalPendingRequests.current - 1;
                                if (totalPendingRequests.current == 0) setIsRequestingMultiple(false);
                            })
                    })
                }
            })
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 row"
            })
        }
    }

    function requestSingleCom() {
        if (func_validation.isObjectNotEmpty(singleCOMDetail)) {
            let rowIndex = singleCOMDetail?.index;
            requestingSingleRowPos.current = rowIndex;
            setIsRequestSuccessful(false);
            setIsRerenderingRequired("");

            let comId = singleCOMDetail?.original?.comId;

            let reason_formatted = isStringTrimNotEmpty(singleCOMReason)? singleCOMReason:"";

            let paramObj = {
                sendEmail: isProjectInProduction,
                requestReason: reason_formatted,
            }
    
            let url = func_serviceHandling.createUrlWithParams((requestType.current == "COM Reactivation"? "/ComInfo/PostReactiveRequest/":"/ComInfo/PostTrialToBillableRequest/") + comId, paramObj);

            if (comId) {
                request(null, (axios) => {
                    axios.post(url)
                        .then((response) => {
                            Toaster({
                                type: "success",
                                msg: "Successfully requested COM"
                            });
    
                            setIsRequestSuccessful(true);
                        })
                        .catch((response) => {
                            let originalMsg = response?.data?.exceptionMessage;
                            Toaster({
                                type: "error",
                                msg: originalMsg? originalMsg: "Failed to request COM",
                                timer: 7000
                            })
                        })
                        .then(() => {
                            requestingSingleRowPos.current = undefined;
                            setIsRerenderingRequired(Math.random());
                        })
                })
            }
        }
        else {
            Toaster({
                type: "info",
                msg: "Table data not loaded properly. Try refreshing the page.",
                timer: 7000
            })
        }
    }

    let requestModal = (
        <ConfirmationModal
            className={"com-reactivation__request-modal"}
            bodyFooterClassName={"request-modal__inputs-wrapper"}
            description={"Confirm COM Request"}
            input={isBooleanFalseNotNullUndefined(isSingleRequest)? (
                selectedCOMs.map((details, idx) => {
                    let comId = details?.comId;

                    return (
                        <div key={idx} className={"inputs-wrapper__inputs d-flex"}>
                             <FormInput_textarea
                                className={"inputs__reason flex-fill"}
                                customInputClassName={"reason__input"}
                                inputLabel={"COM ID: " + comId}
                                inputPlaceholder={"Request Reason Here"}

                                inputValue={selectedCOMReasons?.[idx]}

                                propagateValueChange={(stateName, value) => { 
                                    let newObj = cloneObject(selectedCOMReasons);
                                    newObj[idx] = value;
                                    setSelectedCOMReasons(newObj);
                                }}
                                isResetRequired={!isModalVisible}
                                isMarginBtmOptional
                            />
                        </div>
                    )
                })
            ):(
                <FormInput_textarea
                    className={"inputs-wrapper__reason w-100"}
                    customInputClassName={"reason__input"}

                    inputValue={selectedCOMReasons["0"]}

                    propagateValueChange={(stateName, value) => { 
                        setSingleCOMReason(value);
                    }}

                    isResetRequired={!isModalVisible}
                    isMarginBtmOptional isLabelOptional
                />
            )}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}
            handleOnConfirm={() => {
                if (isSingleRequest) {
                    if (isStringTrimNotEmpty(singleCOMReason)) {
                        requestSingleCom();
                    }
                    else {
                        Toaster({
                            type: "info",
                            msg: "Reason required"
                        })
                    }
                }
                else {
                    let totalReasons = 0;
                    for (let property in selectedCOMReasons) {
                        if (isStringTrimNotEmpty(selectedCOMReasons[property])) {
                            totalReasons++;
                        }
                    }

                    let totalCOMRequests = getArrayLength(selectedCOMs);
                    if (totalCOMRequests === totalReasons) {
                        requestMultipleCom();
                    }
                    else {
                        Toaster({
                            type: "info",
                            msg: "Reason(s) required for each request(s)"
                        })
                    }
                }
            }}
            isActionLoading={isRequestingMultiple}
            isConfirmSuccessful={isRequestSuccessful}
        />
    );

    return {
        requestSingleCom, requestMultipleCom,
        selectedCOMs, setSelectedCOMs,
        selectedCOMReasons, setSelectedCOMReasons,
        isRequestingMultiple,

        isSingleRequest, setIsSingleRequest,
        singleCOMDetail, setSingleCOMDetail,
        singleCOMReason, setSingleCOMReason,

        requestingSingleRowPos,
        isRequestSuccessful,

        requestModal, setIsModalVisible
    }
}